import type { FunctionComponent } from "react"

import dynamic from "next/dynamic"
import { useState } from "react"

import { IconButton } from "@jobteaser/spark/components/IconButton"
import { InfoCircleOutlined } from "@jobteaser/spark/components/Icons/InfoCircleOutlined"

import styles from "./RssFeedModal.module.css"

const ModalDynamic = dynamic(() => import("@/modules/layouts/components/Modal/Modal").then(mod => mod.Modal))

type RssFeedModalProps = {
  closeLabel: string
  title: string
  detail: string
}

export const RssFeedModal: FunctionComponent<RssFeedModalProps> = ({ closeLabel, title, detail }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleModalOpen = (): void => setIsModalOpen(true)
  const handleModalClose = (): void => setIsModalOpen(false)

  return (
    <>
      <IconButton className={styles.button} icon={InfoCircleOutlined} onClick={handleModalOpen} size="small" />

      {isModalOpen && (
        <ModalDynamic closeLabel={closeLabel} onClose={handleModalClose} title={title}>
          {detail}
        </ModalDynamic>
      )}
    </>
  )
}
